import Select from "react-select";
import makeAnimated from "react-select/animated";
import { useEffect, useState } from "react";
import PurchaseService from "../../services/PurchaseOrder";
import { Button, Snackbar, TextField } from "@material-ui/core";

import { Alert } from "@material-ui/lab";
import { selectClasses } from "@mui/material";

const GenerateFactureForPurchasesOrders = () => {
  //   const [purchasesOrdersData, setPurchasesOrdersData] = useState([
  //     { value: 0, label: "" },
  //   ]);

  const [purchasesOrdersData, setPurchasesOrdersData] = useState([]);

  const [selectedValue, setSelectedValue] = useState([]);

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [errorAlertText, setErrorAlertText] = useState();
  const [placeHolder, setPlaceHolder] = useState("Choisir...");
  const animatedComponents = makeAnimated();

  useEffect(() => {
    {
      if (selectedValue.length == 1) {
        purchasesOrdersData.filter(
          (element) => element.label != selectedValue[0]
        );
      }
    }
  }, [selectedValue]);

  useEffect(() => {
    {
      PurchaseService.getAllPOO()
        .then((response) => {
          if (Object.keys(response.data)[0] == "success") {
            response.data.success.map((element, i) => {
              setPurchasesOrdersData((oldArray) => [
                ...oldArray,
                { value: element.reference, label: element.reference },
              ]);
            });
            if (purchasesOrdersData.length == 0) {
              setPlaceHolder("Vide");
            }
          } else if (Object.keys(response.data)[0] == "empty") {
          }
        })
        .catch(() => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un probléme de connection");
        });
    }
  }, []);

  const onChangeSelectedPurchaseOrder = (e) => {
    setSelectedValue(Array.isArray(e) ? e.map((x) => x.value) : []);
    console.log(selectedValue);
    // let value = Array.from(e.target.selectedOptions, (option) => option.value);
    // setSelectedPurchaseOrder(value);
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const onGenerateFactureFromPO = () => {
    PurchaseService.generateFactureFromPurchaseOrder(selectedValue)
      .then((response) => {
        if (Object.keys(response.data)[0] == "success") {
          setSuccessAlertText("le facture est générer avec succès");
          setOpenSuccessAlert(true);
          setSelectedValue([]);
          setPurchasesOrdersData([]);

          PurchaseService.getAllPOO()
            .then((response) => {
              if (Object.keys(response.data)[0] == "success") {
                response.data.success.map((element, i) => {
                  setPurchasesOrdersData((oldArray) => [
                    ...oldArray,
                    { value: element.reference, label: element.reference },
                  ]);
                });
              } else if (Object.keys(response.data)[0] == "empty") {
              }
            })
            .catch(() => {
              setOpenErrorAlert(true);
              setErrorAlertText("Erreur : il ya un probléme de connection");
            });
        } else if (Object.keys(response.data)[0] == "empty") {
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      });
  };

  const placeHolderFunction = () => {
    if (purchasesOrdersData.length == 0) {
      return "Vide";
    } else return "Choisir";
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card  mt-3">
                <div class="card-body">
                  <h5
                    class="card-title"
                    style={{ fontWeight: "bold", marginTop: 7 }}
                  >
                    Vous pouver générer une facture a partir un ou plusieurs
                    achats
                  </h5>
                </div>
              </div>
              <section class="content">
                <div class="card  mt-3">
                  <div class="card-body">
                    <div class="row" style={{ marginTop: 10 }}>
                      <div className="form-group" class="col-sm-10">
                        <label htmlFor="inputClientCompany">
                          Choisir un ou plusieurs achats{" "}
                        </label>
                        {/* <Select
                          closeMenuOnSelect={false}
                          components={animatedComponents}
                          defaultValue={supplierSelectedOption}
                          onChange={onChangeSelectedSupplier}
                          options={setPurchasesOrdersData}
                          isMulti
                          placeholder={purchaseOrderSelectPlaceHolder}
                        /> */}

                        {purchasesOrdersData && (
                          <Select
                            //  closeMenuOnSelect={false}
                            //   components={animatedComponents}
                            className="dropdown"
                            placeholder={
                              purchasesOrdersData.length > 0
                                ? "Choisir "
                                : "Vide"
                            }
                            options={purchasesOrdersData}
                            value={purchasesOrdersData.filter((obj) =>
                              selectedValue.includes(obj.value)
                            )}
                            onChange={onChangeSelectedPurchaseOrder}
                            isMulti
                            isClearable
                          />
                        )}
                      </div>

                      <div className="form-group" class="col-4 col-sm-2">
                        {" "}
                        <div>
                          <button
                            onClick={onGenerateFactureFromPO}
                            style={{ marginTop: 32 }}
                            type="button"
                            class="btn btn-primary"
                          >
                            {" "}
                            Générer
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default GenerateFactureForPurchasesOrders;
